import { FailedAgreementIcon } from "icons/action/FailedIcon";
import { SuccessTick } from "icons/auth/SuccessTick";
import { useNavigate, useParams } from "react-router-dom";
import {
  decode,
  encode,
  customerFacingPaymentError,
} from "utils/HelperFunctions";
import { useTestAttrsFactory } from "utils/testid";

const PaymentAgreementSuccess = ({
  failedReason,
  success,
  requestStatus,
}: any) => {
  const navigate = useNavigate();
  const { id: actionId } = useParams();
  const clusterId = decode(actionId || "")?.split("_")[1];
  let cluster_id = encode(`${clusterId}`, "ci_");
  const testAttrs = useTestAttrsFactory();

  return (
    <>
      {success ? (
        <div
          className="grid place-items-center w-full h-full"
          {...testAttrs(
            requestStatus === "Pending"
              ? "agreement-request-received"
              : "agreement-request-denied",
            requestStatus === "Pending"
              ? "Agreement request received"
              : "Agreement request not approved"
          )}
        >
          <div className="flex items-center justify-center h-full flex-col text-center max-w-[630px] p-5">
            {requestStatus === "Pending" ? (
              <SuccessTick aria-hidden="true" />
            ) : (
              <FailedAgreementIcon aria-hidden="true" />
            )}
            <div className="text-2xl mt-[40px]">
              {requestStatus === "Pending"
                ? "Request received"
                : "Request not approved"}
            </div>
            <div className="text-base mt-[16px] text-txtParagraph ">
              {requestStatus === "Pending"
                ? "Your request for a new payment agreement has been received. We are processing it and will get back to you shortly. We appreciate your patience."
                : "Your request for a new payment agreement could not be approved at this time. Please contact our support team if you need further assistance."}
            </div>
            <div
              className="mt-[24px]  lg:text-base text-sm cursor-pointer text-blue hover:!text-btnPrimaryHover"
              role="button"
              tabIndex={0}
              onClick={() => navigate(`/${cluster_id}/dashboard`)}
              {...testAttrs("back-to-dashboard", "Back to dashboard")}
            >
              Back to dashboard
            </div>
          </div>
        </div>
      ) : (
        <div
          className="grid place-items-center w-full h-full"
          {...testAttrs("agreement-request-failed", "Agreement request failed")}
        >
          <div className="flex items-center justify-center h-full flex-col text-center max-w-[630px] px-5 ">
            <FailedAgreementIcon aria-hidden="true" />
            <div className="text-2xl mt-[40px]">Request Failed!</div>
            <div className="text-base mt-[16px] text-txtParagraph pb-5">
              Your request for a new payment agreement has been failed.
            </div>
            <div className="w-full text-center bg-bgThird lg:py-5 py-4 lg:px-2 px-3 lg:text-lg text-base text-txtParagraph break-words">
              {customerFacingPaymentError(failedReason) || "Payment Failed"}
            </div>
            <div
              className="mt-[24px]  lg:text-base text-sm cursor-pointer text-blue hover:!text-btnPrimaryHover"
              role="button"
              tabIndex={0}
              onClick={() => navigate(`/${cluster_id}/dashboard`)}
              {...testAttrs("back-to-dashboard", "Back to dashboard")}
            >
              Back to dashboard
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default PaymentAgreementSuccess;
